export const ANIMATION_DURATION = 700
